"use client"

import { Button } from "../../../../../shared/components/ui/button"
import { AUTH_PAGE_ROUTE } from "../../../../../shared/constants/pages-routes"
import Link from "next/link"
import { useSignupFormContext } from "../../../hooks"
import { useState } from "react"
import { signupUserStep1Complete } from "../../../actions/auth.action"
import errorToast from "../../../../../shared/lib/toast/error.toast"
import successToast from "../../../../../shared/lib/toast/success.toast"
import { useRouter } from "next/navigation"
import { INVALID_PHONE_ERROR, USER_ALREADY_EXISTS_ERROR } from "../../../constants/backend-errors"

function SucessSignUpFormNavigator() {
    const router = useRouter()
    const {
        trigger,
        getValues,
        setError,
    } = useSignupFormContext()

    const [isLoading, setIsLoading] = useState(false)

    const handleSubmit = async () => {
        setIsLoading(true)
        const isValid = await trigger('form1', { shouldFocus: true })
        try {
            if (isValid) {
                const form1 = getValues('form1')
                if (!form1.fullname || !form1.email || !form1.phone) {
                    errorToast('Please fill in all required fields (Full Name, Email, Phone Number)')
                    return
                }
                const form1ToSubmit: Record<string, unknown> = { ...form1, userType: 'volunteer' }
                if (form1ToSubmit.phone && typeof form1ToSubmit.phone === 'string') {
                    const { transformToE164 } = await import('@/shared/lib/utils/phone.utils')
                    form1ToSubmit.phone = transformToE164(form1ToSubmit.phone)
                }
                const signupUserRes = await signupUserStep1Complete(form1ToSubmit as any)
                if (!signupUserRes.success) throw new Error(signupUserRes.message)
                const email = getValues("form1.email")
                successToast(`Sign-up successful! Welcome aboard. Your email **${email}** has been registered.`)
                router.push(AUTH_PAGE_ROUTE.login)
            }
        } catch (e) {
            const error = e as Error
            switch (error.message) {
                case INVALID_PHONE_ERROR:
                    setError('form1.phone', { message: error.message }, { shouldFocus: true })
                    break
                case USER_ALREADY_EXISTS_ERROR:
                    setError('form1.email', { message: error.message }, { shouldFocus: true })
                    break
                default:
                    errorToast(error.message)
            }
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <Button
                type="button"
                onClick={handleSubmit}
                disabled={isLoading}
                showLoader={isLoading}
            >
                Submit
            </Button>
            <p className='text-sm text-center'>
                {`Already have an account? `}
                <Link
                    href={AUTH_PAGE_ROUTE.login}
                    className='text-primary underline'
                >
                    Sign in
                </Link>
            </p>
        </>
    )
}

export default SucessSignUpFormNavigator